const Spacing = (props) => <div style={{height: props.height}} />
Spacing.defaultProps = {
    height: '30px'
}

export default Spacing;